import ProductTemplate from "../../Biscuits-Template/Template";
import BisImg from "../../../assets/products/cone/Fun cone strawberry.png";
import BiscuitImg from "../../../assets/products/cone/Stawberry-Cone.png";
import { Helmet } from "react-helmet-async";

const BiscuitData = [
  {
    grams: 7,
  },
  {
    grams: 12,
  },
];

export default function StrawberryConeProduct() {
  return (
    <>
      <Helmet>
        <title>Strawberry Cone – BearBitz | Premium Biscuits & Treats</title>
        <meta
          name="description"
          content="Explore BearBitz Strawberry Cone — crispy waffle cones filled with rich strawberry cream. Perfect for global food markets."
        />
        <meta
          name="keywords"
          content="Strawberry Cone, BearBitz Strawberry Cone"
        />
        <link rel="canonical" href="https://www.bearbitz.in/cone/strawberry-cone" />
        <meta property="og:title" content="Strawberry Cone – BearBitz" />
        <meta
          property="og:description"
          content="Crispy waffle cone filled with strawberry-flavored cream by BearBitz, crafted for premium taste and export quality."
        />
      </Helmet>

      <ProductTemplate
        productTitle="STRAWBERRY"
        productImage={BisImg}
        description="Delight in the crunchy Fun Cone, filled with creamy sweetness that makes every bite a joyful treat. Perfect for kids and adults alike, satisfy your sweet cravings anytime."
        tableData={BiscuitData}
        BiscuitLogo={BiscuitImg}
        textColor="#FF009F"
        sectionBgColor="#FFDBF4"
        productBgcolor="#FFADE6"
        tableheadBgcolor="#FF009F"
        tableBgcolor="#FFF3FB"
        footerBgcolor="#FF009F"
      />
    </>
  );
}
